import { PropsWithChildren } from "react";

import { useMatch } from "@tanstack/react-location";

import { ModelProvider } from "./ModelProvider";

export function RouteAwareModelProvider(
  props: PropsWithChildren<{
    paramName: string;
    isUnsavedDraft?: boolean;
  }>,
) {
  const { params } = useMatch();
  const modelId = params[props.paramName];
  return (
    <ModelProvider modelId={modelId} isUnsavedDraft={props.isUnsavedDraft}>
      {props.children}
    </ModelProvider>
  );
}
